function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\xF0\x9F\x92\xB0\xEF\xB8\x8F \xEB\x8F\x88\xEC\xA3\xBC\xEB\xA8\xB8\xEB\x8B\x88",
  clipPath: "url(#clip0_725_40093)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M20 1.99023C22.359 1.99023 22.314 2.85423 23.903 2.93823C25.492 3.02323 26.323 2.52323 27.396 2.68123C28.142 2.79123 28.703 3.12423 29.091 3.45123C29.515 3.80923 29.585 4.43223 29.247 4.87223L25.551 9.67423C25.222 10.0652 25.262 10.6442 25.648 10.9782C31.4 15.9612 38.5 21.9542 38.5 27.3352C38.5 36.3772 31.078 39.1752 20 39.1752C8.922 39.1752 1.5 36.3772 1.5 27.3352C1.5 21.9552 8.6 15.9612 14.352 10.9782C14.738 10.6442 14.778 10.0642 14.449 9.67423L10.753 4.87223C10.415 4.43223 10.485 3.80923 10.909 3.45123C11.297 3.12423 11.858 2.79123 12.604 2.68123C13.677 2.52323 14.509 3.02323 16.097 2.93823C17.686 2.85323 17.641 1.99023 20 1.99023Z",
  fill: "#FFC522"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M20.0834 11.9666C18.1424 11.9666 16.1974 11.7846 14.2994 11.4226C13.6944 11.3066 13.2984 10.7226 13.4134 10.1176C13.5294 9.51262 14.1144 9.11362 14.7184 9.23062C18.2374 9.90162 21.9364 9.90462 25.4154 9.23062C26.0194 9.10962 26.6054 9.50862 26.7224 10.1136C26.8394 10.7186 26.4434 11.3036 25.8384 11.4206C23.9614 11.7836 22.0254 11.9656 20.0834 11.9656V11.9666Z",
  fill: "#99452E"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M20.2396 32.5077C17.6716 32.5077 15.7166 30.9877 14.8986 29.9447C14.4216 29.3357 14.5286 28.4557 15.1376 27.9787C15.7436 27.5047 16.6176 27.6077 17.0966 28.2097C17.2906 28.4487 19.0466 30.4907 21.7996 29.3907C22.4686 29.1237 22.7736 28.6397 22.7286 28.2987C22.6606 27.7777 21.7926 27.1547 20.0086 26.9407C15.6086 26.4127 14.9456 23.9187 14.8466 23.1657C14.6246 21.4657 15.6966 19.8357 17.5146 19.1097C21.1926 17.6437 23.8766 19.6137 24.8596 20.5287C25.4256 21.0547 25.4566 21.9417 24.9296 22.5077C24.4016 23.0727 23.5176 23.1047 22.9506 22.5777C22.0516 21.7397 20.5576 20.9107 18.5516 21.7117C17.8826 21.9787 17.5776 22.4627 17.6226 22.8037C17.6906 23.3247 18.5576 23.9477 20.3416 24.1617C24.7416 24.6897 25.4046 27.1837 25.5036 27.9357C25.7266 29.6357 24.6536 31.2657 22.8366 31.9917C21.9206 32.3567 21.0486 32.5087 20.2386 32.5087L20.2396 32.5077Z",
  fill: "#FFF3CC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M20.1764 21.3858C19.4034 21.3858 18.7764 20.7598 18.7764 19.9868V17.9908C18.7764 17.2178 19.4034 16.5918 20.1764 16.5918C20.9494 16.5918 21.5764 17.2178 21.5764 17.9908V19.9868C21.5764 20.7598 20.9494 21.3858 20.1764 21.3858Z",
  fill: "#FFF3CC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M20.1764 34.5088C19.4034 34.5088 18.7764 33.8828 18.7764 33.1098V31.1138C18.7764 30.3408 19.4034 29.7148 20.1764 29.7148C20.9494 29.7148 21.5764 30.3408 21.5764 31.1138V33.1098C21.5764 33.8828 20.9494 34.5088 20.1764 34.5088Z",
  fill: "#FFF3CC"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_725_40093"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0 0.582031)"
})));

function SvgPaymentcash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentcash);
export default __webpack_public_path__ + "static/media/paymentcash.a3baade6.svg";
export { ForwardRef as ReactComponent };